var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUpArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 6,
  viewBox: "0 0 11 6",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.86544 6L0.711575 6C0.07831 6 -0.238322 5.2351 0.209944 4.78684L4.7851 0.208123C5.0626 -0.0693755 5.51442 -0.0693755 5.79192 0.208123L10.3671 4.78684C10.8153 5.2351 10.4987 6 9.86544 6Z",
  fill: "black"
})));
export default __webpack_public_path__ + "static/media/Up_Arrow.55b39cd2.svg";
export { SvgUpArrow as ReactComponent };